import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CartridgeServicePackage, Price } from '@markant-platform/cartridge/model';
import { formatPriceWithCurrencyPipe } from '@markant-platform/shared/util-helpers';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'markant-platform-price-scale',
  templateUrl: './price-scale.component.html',
  styleUrls: ['./price-scale.component.scss'],
})
export class PriceScaleComponent implements OnChanges {
  @Input() price!: Price;
  @Input() servicePackage?: CartridgeServicePackage[];
  @Input() small = false;

  isFixedPrice!: boolean;

  constructor(private readonly formatter: CurrencyPipe) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['price']) {
      this.isFixedPrice = this.price.priceModel === 'STAGGERED_FIXED_PRICE';
    }
  }

  formatPrice(deciMillis: number, currency: string): string | null {
    return formatPriceWithCurrencyPipe(deciMillis, currency, this.formatter);
  }
}
